import React, { useEffect } from 'react';
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer'
import classes from './Blogdetails.module.css'
import blogdtlsimg from '../../Assets/blogdtlshero.png'
import blogdtlsimgmble from '../../Assets/Image.png'
import cntntimg from '../../Assets/cntntimg.png'
import { Link, useLocation } from 'react-router-dom';
import arrowup from '../../Assets/arrow-up-right.png';

const Blogdetails = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const location = useLocation();

useEffect(() => {
    window.scrollTo(0, 0);
}, [location]);


    return (
        <>
            <Navigation />
            <div className={classes.blogdtls}>

                <section>
                    <p className={classes.blogdetailshd}>UX review presentations</p>
                    <p className={classes.blogdetailsnd2}>How do you create compelling presentations that wow your colleagues and impress your managers?</p>
                    <img src={blogdtlsimg} className={classes.heeroimg} />
                    <img src={blogdtlsimgmble} className={classes.heeroimgmble} />
                </section>
                <section className={classes.blogdetailsnd3}>
                    <div className={classes.blogdetailsnd}>
                        <p className={classes.introptxt} >Introdution</p>
                        <p className={classes.introptxt2}>
                            Mi tincidunt elit, id quisque ligula ac diam, amet. Vel etiam suspendisse morbi eleifend faucibus eget vestibulum felis. Dictum quis montes, sit sit. Tellus aliquam enim urna, etiam. Mauris posuere vulputate arcu amet, vitae nisi, tellus tincidunt. At feugiat sapien varius id. <br />
                            <span className={classes.brshi}>  Eget quis mi enim, leo lacinia pharetra, semper. Eget in volutpat mollis at volutpat lectus velit, sed auctor. Porttitor fames arcu quis fusce augue enim. Quis at habitant diam at. Suscipit tristique risus, at donec. In turpis vel et quam imperdiet. Ipsum molestie aliquet sodales id est ac volutpat. </span>
                        </p>
                        <img src={cntntimg} className={classes.blogdetailsndimg} />
                        <p className={classes.ref}>Image courtesy of Laura Davidson via <a href='https://unsplash.com/photos/QBAH4IldaZY'>Unsplash</a></p>
                        <div className={classes.blogdetailsnd02}>
                            <p className={classes.italicshi}>“In a world older and more complete than ours they move finished and complete, gifted with extensions of the senses we have lost or never attained, living by voices we shall never hear.”</p>
                            <p className={classes.writr}>— Olivia Rhye, Product Designer</p>
                        </div>
                        <p className={classes.introptxt2}>
                            Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio nisl vitae. In aliquet pellentesque aenean hac vestibulum turpis mi bibendum diam. Tempor integer aliquam in vitae malesuada fringilla. <br />
                            <span className={classes.brshi}> Elit nisi in eleifend sed nisi. Pulvinar at orci, proin imperdiet commodo consectetur convallis risus. Sed condimentum enim dignissim adipiscing faucibus consequat, urna. Viverra purus et erat auctor aliquam. Risus, volutpat vulputate posuere purus sit congue convallis aliquet. Arcu id augue ut feugiat donec porttitor neque. Mauris, neque ultricies eu vestibulum, bibendum quam lorem id. Dolor lacus, eget nunc lectus in tellus, pharetra, porttitor. </span>
                            <br />
                            <span > Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci. </span>
                        </p>
                    </div>
                </section>

                <section className={classes.blogdetailsnd4}>
                    <p className={classes.blogdetailsnd4hd}>From the blog</p>
                    <p className={classes.blogdetailsnd4txt}>The latest industry news, interviews, technologies, and resources.</p>

                    <div className={classes.blogPostContainerentire}>
                        <Link to={'/blog_details'} ><div className={classes.blogPostContainerall}>
                            <div className={classes.blogPostContainer}>
                                <div className={classes.blogPost}>
                                    <div className={classes.blogPost1}>
                                        <p className={classes.blogger}>Olivia Rhye</p>
                                        <p className={classes.bloggerdte}>20 Jan 2022</p>
                                    </div>
                                    <p className={classes.bloggertitle}>Design</p>
                                </div>
                            </div>

                            <div className={classes.blogPostContainer2}>
                                <div className={classes.blogPosttxt}>
                                    <p className={classes.uxrvw}>UX review presentations</p>
                                    <p className={classes.rvwbdy}>How do you create compelling presentations that wow your colleagues and impress your managers?</p>
                                    <Link to={'/blog_details'} > <div className={classes.readPost}>
                                        <p className={classes.rdpst} style={{ marginTop: '12px' }}>Read post</p>
                                        <img src={arrowup} className={classes.arrow} alt="arrow" />
                                    </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        </Link>
                        <Link to={'/blog_details'} ><div className={classes.blogPostContainerall}>
                            <div className={classes.blogPostContainer22}>
                                <div className={classes.blogPost}>
                                    <div className={classes.blogPost1}>
                                        <p className={classes.blogger}>Phoenix Baker</p>
                                        <p className={classes.bloggerdte}>19 Jan 2022</p>
                                    </div>
                                    <p className={classes.bloggertitle}>Design</p>
                                </div>
                            </div>

                            <div className={classes.blogPostContainer2}>
                                <div className={classes.blogPosttxt}>
                                    <p className={classes.uxrvw}>Migrating to Linear 101</p>
                                    <p className={classes.rvwbdy}>Linear helps streamline software projects, sprints, tasks, and bug tracking. Here’s how to get started.</p>
                                    <Link to={'/blog_details'} ><div className={classes.readPost}>
                                        <p className={classes.rdpst} style={{ marginTop: '12px' }}>Read post</p>
                                        <img src={arrowup} className={classes.arrow} alt="arrow" />
                                    </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        </Link>
                    </div>
                    <div className={classes.blogPostContainerentire}>
                        <Link to={'/blog_details'} ><div className={classes.blogPostContainerall}>
                            <div className={classes.blogPostContainer12}>
                                <div className={classes.blogPost}>
                                    <div className={classes.blogPost1}>
                                        <p className={classes.blogger}>Lana Steiner</p>
                                        <p className={classes.bloggerdte}>18 Jan 2022</p>
                                    </div>
                                    <p className={classes.bloggertitle}>Design</p>
                                </div>
                            </div>

                            <div className={classes.blogPostContainer2}>
                                <div className={classes.blogPosttxt}>
                                    <p className={classes.uxrvw}>Building your API Stack</p>
                                    <p className={classes.rvwbdy}>The rise of RESTful APIs has been met by a rise in tools for creating, testing, and managing them.</p>
                                    <Link to={'/blog_details'} > <div className={classes.readPost}>
                                        <p className={classes.rdpst} style={{ marginTop: '12px' }}>Read post</p>
                                        <img src={arrowup} className={classes.arrow} alt="arrow" />
                                    </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        </Link>
                        <Link to={'/blog_details'} ><div className={classes.blogPostContainerall}>
                            <div className={classes.blogPostContainer23}>
                                <div className={classes.blogPost}>
                                    <div className={classes.blogPost1}>
                                        <p className={classes.blogger}>Alec Whitten</p>
                                        <p className={classes.bloggerdte}>17 Jan 2022</p>
                                    </div>
                                    <p className={classes.bloggertitle}>Design</p>
                                </div>
                            </div>

                            <div className={classes.blogPostContainer2}>
                                <div className={classes.blogPosttxt}>
                                    <p className={classes.uxrvw}>Bill Walsh leadership lessons</p>
                                    <p className={classes.rvwbdy}>Like to know the secrets of transforming a 2-14 team into a 3x Super Bowl winning Dynasty?</p>
                                    <Link to={'/blog_details'} ><div className={classes.readPost}>
                                        <p className={classes.rdpst} style={{ marginTop: '12px' }}>Read post</p>
                                        <img src={arrowup} className={classes.arrow} alt="arrow" />
                                    </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        </Link>
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
}

export default Blogdetails;
